import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// Connects to data-controller="select-change"
export default class extends Controller {
  
  get frameElement() {
    return this.element.closest("turbo-frame")    
  }
  
  get currentURL() {
    if (this.frameElement?.src) return new URL(this.frameElement.src)
    return new URL(window.location.href)
  }
  
  onChange(e) {
    if (this.element.tagName.toLowerCase() == "form") {
      this.submitForm(e)
    } else {
      this.visitURL(e)
    }
  }

  submitForm(e) {
    e.target.classList.add('select-flash')
    e.target.addEventListener('animationend', () => e.target.classList.remove('select-flash'), { once: true })
    e.target.blur()
    this.element.requestSubmit()
  }

  visitURL(e) {
    const url = this.currentURL
    url.searchParams.set(e.target.name, e.target.value)
    if (this.frameElement) {
      this.frameElement.src = url
    } else {
      Turbo.visit(url)      
    }
  }
  
}
